'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconStyle = require('./icon.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fraction = function Fraction(allProps) {
  var style = {
    width: '1em',
    height: '1em'
  };
  var className = allProps.className,
      props = (0, _objectWithoutProperties3.default)(allProps, ['className']);

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      viewBox: '0 0 1024 1024',
      style: style,
      title: 'fraction icon',
      preserveAspectRatio: 'xMidYMid meet',
      className: (0, _classnames2.default)(_iconStyle.monoIconStyle, className)
    }, props),
    _react2.default.createElement('path', { d: 'M167.2 251.7v512.2H88V338L3.6 381.2v-78.6l101-51h62.6zm247.2 0v512.2h-79.3V338L251 381.2v-78.6l101-51h62.5zm210.1 0h70l-145 512.2h-70l145-512.2zm397.7 405.5h-56.4v106.7h-73V657.2H685.1v-70.1l177.2-335.4H941L765 583.3h127.6V443.8h73.1v139.5h56.4v73.9z'
    })
  );
};

exports.default = Fraction;